import {INTERFRAMEMESSAGES} from "./InterframeMessages";
import {createGUID, noop} from "./globalUtils";
import {EventListener} from "./eventVerteiler";

export interface BusyIndicator{
    busy(requestIdentifier):void;
    finished(requestIdentifier):void;
}

export class ScreenBlockerBusyIndicator implements BusyIndicator {
    private eventVerteiler:{broadcastBlockRequest, broadcastBlockRequestEnded};

    public constructor(eventVerteiler) {
        this.eventVerteiler = eventVerteiler;
    }


    busy(requestIdentifier): void {
        this.eventVerteiler.broadcastBlockRequest(requestIdentifier);
    }

    finished(requestIdentifier): void {
        this.eventVerteiler.broadcastBlockRequestEnded(requestIdentifier);
    }
}


export type AjaxSettings = {
    type,
    url,
    data,
    dataType,
    requestedDatatypeWasJSON?;
};

export class AjaxSettingGetter {
    static getSettings(url, data, method, datatype):AjaxSettings {
        return {
            type: method,
            url: url,
            data: data,
            dataType: datatype
        };
    }
}

export class JQueryAjaxConnector extends EventListener{

    private static busyIndicator:BusyIndicator = {busy:noop, finished:noop};
    private static username;

    constructor(busyIndicator: BusyIndicator, username) {
        super();
        JQueryAjaxConnector.busyIndicator = busyIndicator;
        JQueryAjaxConnector.username = username;
        this.initEvenListeners()
    }

    private initEvenListeners() {
        this
            .addEventListener(INTERFRAMEMESSAGES.LOGOUT_SUCCEEDED, (data)=>JQueryAjaxConnector.username = data.username)
            .addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_SUCCESS, (data)=>JQueryAjaxConnector.username = data.username)
        ;
    }

    protected static busy = (requestIdentifier)=>JQueryAjaxConnector.busyIndicator.busy(requestIdentifier);
    protected static finished = (requestIdentifier)=>JQueryAjaxConnector.busyIndicator.finished(requestIdentifier);

    protected static ajaxFailed(requestIdentifier, onerror)  {
        JQueryAjaxConnector.finished(requestIdentifier);
        onerror();
    }

    protected static ajaxFinished(requestIdentifier, data, expectJSON, onsuccess, onSessionTimedout=null) {
        JQueryAjaxConnector.finished(requestIdentifier);
        if(data === "sessionexpired") {
            JQueryAjaxConnector.sessionTimedOut(onSessionTimedout);
            return;
        }
        if(expectJSON) {
            onsuccess(JQueryAjaxConnector.tryJsonParsingAndReturnUnchangedIfNotPossible(data));
        } else {
            onsuccess(data);
        }
    }

    private static tryJsonParsingAndReturnUnchangedIfNotPossible(data) {
        try {
            return JSON.parse(data)
        } catch (e) {
            return data;
        }
    }

    private static sessionTimedOut(onSessionTimedOut) {
        if(typeof(onSessionTimedOut) === "function") {
            onSessionTimedOut();
        } else {
            window.location.reload();
        }
    }

    protected static sendRequest(ajaxSettings, requestIdentifier, onsuccess, onerror, onSessionTimedout=null) {
        $.ajax(ajaxSettings)
            .fail(function () {
                JQueryAjaxConnector.ajaxFailed(requestIdentifier, typeof(onerror) === "function" ? onerror() : console.log("noop"));
            })
            .done(function (data) {
                JQueryAjaxConnector.ajaxFinished(requestIdentifier, data, ajaxSettings.requestedDatatypeWasJSON, onsuccess, onSessionTimedout);
            });
    }
    public static send(ajaxSettings:AjaxSettings, onsuccess: (data) => void, onerror) {
        ajaxSettings.data.sessionUsername = JQueryAjaxConnector.username;
        if(ajaxSettings.dataType === "json") {
            ajaxSettings.dataType = "text";
            ajaxSettings.requestedDatatypeWasJSON = true;
        } else {
            ajaxSettings.requestedDatatypeWasJSON = false;
        }
        const requestIdentifier = createGUID();
        JQueryAjaxConnector.busy(requestIdentifier);
        this.sendRequest(ajaxSettings, requestIdentifier, onsuccess, onerror);
    }

    public static getSettings(url, data={}, method="POST", datatype="json"):AjaxSettings {
        return AjaxSettingGetter.getSettings(url, data, method, datatype)
    }


}

